module.exports = __webpack_public_path__ + "img/degustation.296274d9.jpg";